import React from 'react';
import { Col, Container , Row} from 'react-bootstrap';
import { Authenticator } from '@aws-amplify/ui-react';
import SiteCard from './SiteCard';


export const CallToJoin = () => {
  return (
    <Container style={{ width: '100%' }}>
<SiteCard
    header="Create a Free Account or Subscribe"
    title="Try it free - no card required"
    content={
      <Container>
        <Row className="justify-content-center align-items-center" style={{ minHeight: '100%' }}>
          <Col md={8} className="text-center">
            <h5>Get Started Today</h5>
            <p>Create a free account to access:</p>
            <ul style={{ textAlign: 'left', maxWidth: '400px', margin: '0 auto' }}>
              <li>3 ML predictions per day</li>
              <li>Maps with regional views</li>
            </ul>
            <br />
            <p><strong>Or subscribe for £3.99/month for:</strong></p>
            <ul style={{ textAlign: 'left', maxWidth: '400px', margin: '0 auto' }}>
              <li>Unlimited predictions & data export</li>
              <li>Street and postcode-level map detail</li>
              <li>API access</li>
            </ul>
            <p style={{ marginTop: '1rem' }}>Cancel anytime. Your support helps keep this project running!</p>
            </Col>
            </Row>
            <Container>
              <Authenticator />
            </Container>
            <br />

            <Row className="justify-content-center align-items-center" style={{ minHeight: '100%' }}>

            <Col md={6} className="text-center">
            <p>Thank you for considering joining!</p>
            </Col>
            </Row>

      </Container>
    }
/>

    </Container>
  );
};



export const CallToJoinPredictor = () => {
  return (
    <Container style={{ width: '100%' }}>
<SiteCard
    header="Sign In or Create Free Account"
    content={

            <Container fluid className="h-100">

                                <Row className="h-100 align-items-center" style={{ minHeight: '40vh' }}>
                                <Col md={6} className="d-flex align-items-center justify-content-center">
                                        <img src="/predictor.webp" alt="First-Ever ML Prediction Tool" className="img-fluid rounded shadow site-card-image" />
                                    </Col>
                                    <Col md={6} className="d-flex flex-column justify-content-center">
                                        <h3 className="text-center" style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                                            ML Property Price Predictor
                                        </h3>
                                        <p>
                                            <strong>The market's first</strong> machine learning tool for property prediction.
                                        </p>
                                        <p>
                                            <strong>Free Account:</strong> 3 predictions per day
                                        </p>
                                        <p>
                                            <strong>Subscribers get:</strong>
                                        </p>
                                        <ul>
                                            <li>Unlimited predictions</li>
                                            <li>Download & export history</li>
                                            <li>Full access to all tools</li>
                                        </ul>
                                        <p>
                                            Sign in or create a free account to get started!
                                        </p>

                                    </Col>

                                </Row>
              <Container>
              <Authenticator />
            </Container>
            </Container>

    }
/>

    </Container>
  );
};

